// Einzige Stelle für den Status der Pilotanlage Kantstraße.
// Nach dem Rückbau (Ende September 2026) nur hier anpassen.
const WHERE_DE =
  "Seit Juni 2026 steht die erste vollständige Anlage in der Berliner Kantstraße, zwischen Waldorf Astoria und Upper West — bepflanzt, beleuchtet, begehbar.";
const WHERE_EN =
  "Since June 2026, the first complete installation has stood on Berlin's Kantstraße, between the Waldorf Astoria and Upper West — planted, lit, walkable.";

export const KANT = {
  de: {
    title: "Seit Juni 2026 in der Kantstraße",
    status:
      "Die Anlage steht noch bis Ende September 2026, dann wird sie planmäßig zurückgebaut — ohne Fundament aufgestellt, rückstandslos wieder weg.",
    where: WHERE_DE,
    get whereStatus() {
      return `${WHERE_DE} ${this.status}`;
    },
  },
  en: {
    title: "In the Kantstraße since June 2026",
    status:
      "The installation remains in place until the end of September 2026, when it will be dismantled as planned — set up without foundations, removed without trace.",
    where: WHERE_EN,
    get whereStatus() {
      return `${WHERE_EN} ${this.status}`;
    },
  },
};
